<template>
    <div class='h100vh-100'>
        <ThresholdBar ref="ThresholdBar" :taskStatus="taskStatus" :gnbCounterTreeClickInfo="gnbCounterTreeClickInfo"></ThresholdBar>
        <ThresholdList ref="ThresholdList" :gnbCounterTreeClickInfo="gnbCounterTreeClickInfo"></ThresholdList>

        <!-- 新增自定义指标 -->
        <CustomDialog ref='CreateThresholdDialog' :element='createThresholdDialog.element' :styles='createThresholdDialog.style'>
            <template v-slot:dialog-content>
                <CreateThresholdDialog ref='createThresholdDialog' :gnbCounterTreeClickInfo="gnbCounterTreeClickInfo"></CreateThresholdDialog>
            </template>
        </CustomDialog>

        <CustomDialog ref="ThresholdDetailDialog" :element='thresholdDetailDialog.element' :styles='thresholdDetailDialog.style'>
            <template v-slot:dialog-content>
                <ThresholdDetailDialog ref="ThresholdDetail" ></ThresholdDetailDialog>
            </template>
        </CustomDialog>
    </div>
</template>

<script>

    import CustomDialog from "../../../../common/CustomDialog";
    import ThresholdBar from "./ThresholdBar";
    import ThresholdList from "./ThresholdList";
    import CreateThresholdDialog from "./dialog/CreateThresholdDialog";
    import ThresholdDetailDialog from "./dialog/ThresholdDetailDialog";

    import {EventBus} from "../../../../../plugins/eventBus";

    export default {
        name: 'Threshold',

        components: {
            CustomDialog,
            ThresholdBar,
            ThresholdList,
            CreateThresholdDialog,
            ThresholdDetailDialog,
        },

        props: [
            'gnbCounterTreeClickInfo'
        ],
        data() {
          return {
              createThresholdDialog: {
                  style: {
                      width: '800px',
                      height: 'auto',
                      visible: false,
                      model: true
                  },
                  element: {
                      title: this.$t('Pm.thresholdSetting'),
                      target: this.$refs.ThresholdList,
                      refName: 'addThresholdElement',
                      buttonGroup: [
                          { click: this.closeCreateThresholdDialog, buttonModel: { content: this.$t('Common.cancel') } },
                          { click: this.addThreshold, buttonModel: { content: this.$t('Pm.finish'), isPrimary: true } }
                      ],
                      isClose: true
                  }
              },
              thresholdDetailDialog: {
                  style: {
                      width: '800px',
                      height: 'auto',
                      visible: false,
                      model: true
                  },
                  element: {
                      title: this.$t('Pm.thresholdDetail'),
                      target: this.$refs.ThresholdList,
                      refName: 'thresholdDetailElement',
                      buttonGroup: [
                          { click: this.closeThresholdDetailDialog, buttonModel: { content: this.$t('Common.cancel') } }
                      ],
                      isClose: true
                  }
              },
              thresholdTitle: '',
              thresholdInfo: {},
              taskStatus: '',
              isExists: false
          }
        },
        methods: {
            taskStatusChange(msg) {
                this.taskStatus = msg;
            },
            methodList(operator){
                switch(operator){
                    case 'create':
                        this.createThreshold();
                        break;
                    case 'detail':
                        this.openThresholdDetail();
                        break;
                    case 'active':
                        this.activeThreshold();
                        break;
                    case 'hangup':
                        this.hangupThreshold();
                        break;
                    default:
                        break;
                }
            },
            searchByCounterName(counterName){
                this.$refs.ThresholdList.getThresholdListData(counterName);
            },
            taskStatusChange(activeStatus){
                this.taskStatus = activeStatus;
            },
            async activeThreshold(){
                const data = this.$refs.ThresholdList.rowDataOfCustomCounter;
                if (data == null || data == '') {
                    EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
                    return;
                }
                this.$loading.showLoadding(this.$t('System.loading'));
                await this.$axios.post('/lte/ems/pm/counterManagement/activeCounterThresholdGnb.html', {
                    neTypeCode: data.neTypeCode,
                    neVersion: data.neTypeVersion,
                    counterCode: data.counterCode+data.measureObjNameOT,
                }).then(response => {
                    console.log('activeCounterThresholdResponse',response);
                });
                this.$refs.ThresholdList.getThresholdListData();
                this.$loading.hideLoadding();

            },

            async hangupThreshold(){
                const data = this.$refs.ThresholdList.rowDataOfCustomCounter;
                if (data == null || data == '') {
                    EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
                    return;
                }
                this.$loading.showLoadding(this.$t('System.loading'));
                await this.$axios.post('/lte/ems/pm/counterManagement/hangUpCounterThresholdGnb.html', {
                    neTypeCode: data.neTypeCode,
                    neVersion: data.neTypeVersion,
                    counterCode: data.counterCode+data.measureObjNameOT,
                }).then(response => {
                    console.log('hangupThresholdResponse',response);
                });
                this.$refs.ThresholdList.getThresholdListData();
                this.$loading.hideLoadding();
            },
            createThreshold(){
                const data = this.$refs.ThresholdList.rowDataOfCustomCounter;
                this.createThresholdDialog.element.title = `${(this._i18n.locale === 'zh') ? data.counterNameCH : data.counterNameOT}：${this.$t('Pm.thresholdSetting')}`;
                if (data == null || data == '') {
                    EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
                    return;
                }
                this.$axios.post('/lte/ems/pm/counterManagement/getCounterThresholdGnb.html', {
                  neTypeCode: data.neTypeCode,
                  neVersion: data.neTypeVersion,
                  counterCode: data.counterCode+data.measureObjNameOT,
                }).then((response) => {
                  let data = response.data.resultVal;
                  if(data != null){
                    this.$layer.confirm({
                      msg: this.$t('Pm.thresholdExistUpdateOrNot'),
                      btn1: {
                        msg: this.$t('System.cancel'),
                      },
                      btn2: {
                        msg: this.$t('System.confirm'),
                        func: () => {
                          this.isExists = true;
                          this.$refs.createThresholdDialog.bindValidateOfAddThreShold();
                          this.$refs.CreateThresholdDialog.show();
                        }
                      }
                    });
                  }else{
                    this.isExists = false;
                    this.$refs.createThresholdDialog.bindValidateOfAddThreShold();
                    this.$refs.CreateThresholdDialog.show();
                  }
                });
            },

            async openThresholdDetail() {
              const data = this.$refs.ThresholdList.rowDataOfCustomCounter;
              this.createThresholdDialog.element.title = `${(this._i18n.locale === 'zh') ? data.counterNameCH : data.counterNameOT}：${this.$t('Pm.thresholdDetail')}`;
              if (data == null || data == '') {
                EventBus.$emit('toast', {type: 'warning', content: this.$t('Pm.selectDataPlease')});
                return;
              }
              await this.$axios.post('/lte/ems/pm/counterManagement/getCounterThresholdGnb.html', {
                neTypeCode: data.neTypeCode,
                neVersion: data.neTypeVersion,
                counterCode: data.counterCode+data.measureObjNameOT,
              }).then((response) => {
                this.thresholdInfo = response.data.resultVal;
              });
              this.$refs.ThresholdDetail.detailParams = {
                neTypeName: data.neTypeName,
                neTypeVersion: '--',
                counterName: (this._i18n.locale === 'zh') ? data.counterNameCH : data.counterNameOT,
                unitName: (this._i18n.locale === 'zh') ? data.unitCH : data.unitOT,
                level0Value: this.thresholdInfo == null || (this.thresholdInfo.level0Lower == null && this.thresholdInfo.level0Upper == null) ? this.$t('Pm.notSet') : (this.thresholdInfo.level0Lower == null ? `${this.$t('Pm.lowUnlimited')}~${this.thresholdInfo.level0Upper}`: (this.thresholdInfo.level0Upper == null ? `${this.thresholdInfo.level0Lower}~${this.$t('Pm.upperUnlimited')}` : `${this.thresholdInfo.level0Lower}~${this.thresholdInfo.level0Upper}`)),
                level1Value: this.thresholdInfo == null || (this.thresholdInfo.level1Lower == null && this.thresholdInfo.level1Upper == null) ? this.$t('Pm.notSet') : (this.thresholdInfo.level1Lower == null ? `${this.$t('Pm.lowUnlimited')}~${this.thresholdInfo.level1Upper}`: (this.thresholdInfo.level1Upper == null ? `${this.thresholdInfo.level1Lower}~${this.$t('Pm.upperUnlimited')}` : `${this.thresholdInfo.level1Lower}~${this.thresholdInfo.level1Upper}`)),
                level2Value: this.thresholdInfo == null || (this.thresholdInfo.level2Lower == null && this.thresholdInfo.level2Upper == null) ? this.$t('Pm.notSet') : (this.thresholdInfo.level2Lower == null ? `${this.$t('Pm.lowUnlimited')}~${this.thresholdInfo.level2Upper}`: (this.thresholdInfo.level2Upper == null ? `${this.thresholdInfo.level2Lower}~${this.$t('Pm.upperUnlimited')}` : `${this.thresholdInfo.level2Lower}~${this.thresholdInfo.level2Upper}`)),
                level3Value: this.thresholdInfo == null || (this.thresholdInfo.level3Lower == null && this.thresholdInfo.level3Upper == null) ? this.$t('Pm.notSet') : (this.thresholdInfo.level3Lower == null ? `${this.$t('Pm.lowUnlimited')}~${this.thresholdInfo.level3Upper}`: (this.thresholdInfo.level3Upper == null ? `${this.thresholdInfo.level3Lower}~${this.$t('Pm.upperUnlimited')}` : `${this.thresholdInfo.level3Lower}~${this.thresholdInfo.level3Upper}`))
              };
              this.$refs.ThresholdDetailDialog.show();
            },
            closeCreateThresholdDialog(){
                this.$refs.CreateThresholdDialog.close();
            },
            async addThreshold() {
                const data = this.$refs.ThresholdList.rowDataOfCustomCounter;

                const ruleDatas = this.$refs.createThresholdDialog.validateOfAddThreShold();
                if (!ruleDatas) {
                    return;
                }

                let thresholdParams = this.$refs.createThresholdDialog.thresholdParams;

                const level0Lower = thresholdParams.level0Lower == '' || thresholdParams.level0Lower == null ? null : parseInt(thresholdParams.level0Lower);
                const level0Upper = thresholdParams.level0Upper == '' || thresholdParams.level0Upper == null ? null : parseInt(thresholdParams.level0Upper);

                let nullFlag = true;

                if (level0Lower != null || level0Upper != null) {
                    nullFlag = false;
                    if (!(level0Lower != null && level0Upper != null)) {
                        EventBus.$emit('toast', {type: 'warning', content: this.$t('Pm.emergencyAlarmUpperAndLowerAllNeed')});
                        return;
                    }
                    if (level0Lower >= level0Upper) {
                        EventBus.$emit('toast', {type: 'warning', content: this.$t('Pm.emergencyAlarmUpperMore')});
                        return;
                    }
                }

                const level1Lower = thresholdParams.level1Lower == '' || thresholdParams.level1Lower == null ? null : parseInt(thresholdParams.level1Lower);
                const level1Upper = thresholdParams.level1Upper == '' || thresholdParams.level1Upper == null ? null : parseInt(thresholdParams.level1Upper);
                if (level1Lower != null || level1Upper != null) {
                    nullFlag = false;
                    if (!(level1Lower != null && level1Upper != null)) {
                        EventBus.$emit('toast', {type: 'warning', content: this.$t('Pm.importantAlarmUpperAndLowerAllNeed')});
                        return;
                    }
                    if (level1Lower >= level1Upper) {
                        EventBus.$emit('toast', {type: 'warning', content: this.$t('Pm.importantAlarmUpperMore')});
                        return;
                    }
                }

                const level2Lower = thresholdParams.level2Lower == '' || thresholdParams.level2Lower == null ? null : parseInt(thresholdParams.level2Lower);
                const level2Upper = thresholdParams.level2Upper == '' || thresholdParams.level2Upper == null ? null : parseInt(thresholdParams.level2Upper);
                if (level2Lower != null || level2Upper != null) {
                    nullFlag = false;
                    if (!(level2Lower != null && level2Upper != null)) {
                        EventBus.$emit('toast', {type: 'warning', content: this.$t('Pm.secondaryAlarmUpperAndLowerAllNeed')});
                        return;
                    }
                    if (level2Lower >= level2Upper) {
                        EventBus.$emit('toast', {type: 'warning', content: this.$t('Pm.secondaryAlarmUpperMore')});
                        return;
                    }
                }

                const level3Lower = thresholdParams.level3Lower == '' || thresholdParams.level3Lower == null ? null : parseInt(thresholdParams.level3Lower);
                const level3Upper = thresholdParams.level3Upper == '' || thresholdParams.level3Upper == null ? null : parseInt(thresholdParams.level3Upper);
                if (level3Lower != null || level3Upper != null) {
                    nullFlag = false;
                    if (!(level3Lower != null && level3Upper != null)) {
                      EventBus.$emit('toast', {type: 'warning', content: this.$t('Pm.promptAlarmUpperAndLowerAllNeed')});
                      return;
                    }
                    if (level3Lower >= level3Upper) {
                        EventBus.$emit('toast', {type: 'warning', content: this.$t('Pm.promptAlarmUpperMore')});
                        return;
                    }
                }

              if(nullFlag){
                if(this.isExists){
                  this.$layer.confirm({
                    msg: this.$t(this.$t('Pm.thresholdEmptyDelete')),
                    btn1: {
                      msg: this.$t('System.cancel'),
                    },
                    btn2: {
                      msg: this.$t('System.confirm'),
                      func: async () => {
                        this.$loading.showLoadding(this.$t('System.loading'));
                        await this.$axios.post('/lte/ems/pm/counterManagement/createCounterThresholdGnb.html', {
                          neTypeCode: data.neTypeCode,
                          neTypeName: data.neTypeName,
                          neVersion: '--',
                          measureObjCode: data.measureObjCode,
                          measureObjName: data.measureObjNameCH,
                          counterCode: data.counterCode+data.measureObjNameOT,
                          counterName: data.counterNameCH,
                          counterUnitName: data.unitCH,
                          level0Lower: thresholdParams.level0Lower,
                          level0Upper: thresholdParams.level0Upper,
                          level1Lower: thresholdParams.level1Lower,
                          level1Upper: thresholdParams.level1Upper,
                          level2Lower: thresholdParams.level2Lower,
                          level2Upper: thresholdParams.level2Upper,
                          level3Lower: thresholdParams.level3Lower,
                          level3Upper: thresholdParams.level3Upper,
                        }).then(response => {
                          if (response != null && response.data == 1) {
                            EventBus.$emit('toast', {type: 'success', content: this.$t('Pm.thresholdSettingSuccess')});
                          } else if (response != null && response.data == 2) {
                            EventBus.$emit('toast', {type: 'success', content: this.$t('Pm.thresholdUpdateSuccess')});
                          } else {
                            EventBus.$emit('toast', {type: 'success', content: this.$t('Pm.thresholdSettingFail')});
                          }
                        });
                        this.$refs.CreateThresholdDialog.close();
                        this.$refs.ThresholdList.getThresholdListData();
                        this.$loading.hideLoadding();
                      }
                    }
                  });
                }else{
                  EventBus.$emit('toast', {type: 'warning', content: this.$t('Pm.thresholdCanNotAllEmpty')});
                  return;
                }

              }else{
                this.$loading.showLoadding(this.$t('System.loading'));
                await this.$axios.post('/lte/ems/pm/counterManagement/createCounterThresholdGnb.html', {
                  neTypeCode: data.neTypeCode,
                  neTypeName: data.neTypeName,
                  neVersion: '--',
                  measureObjCode: data.measureObjCode,
                  measureObjName: data.measureObjNameCH,
                  counterCode: data.counterCode+data.measureObjNameOT,
                  counterName: data.counterNameCH,
                  counterUnitName: data.unitCH,
                  level0Lower: thresholdParams.level0Lower,
                  level0Upper: thresholdParams.level0Upper,
                  level1Lower: thresholdParams.level1Lower,
                  level1Upper: thresholdParams.level1Upper,
                  level2Lower: thresholdParams.level2Lower,
                  level2Upper: thresholdParams.level2Upper,
                  level3Lower: thresholdParams.level3Lower,
                  level3Upper: thresholdParams.level3Upper,
                }).then(response => {
                  if(response != null && response.data == 1){
                    EventBus.$emit('toast', { type: 'success', content: this.$t('Pm.thresholdSettingSuccess') });
                  }else if(response != null && response.data == 2){
                    EventBus.$emit('toast', { type: 'success', content: this.$t('Pm.thresholdUpdateSuccess') });
                  }else{
                    EventBus.$emit('toast', { type: 'success', content: this.$t('Pm.thresholdSettingFail') });
                  }
                });
                this.$refs.CreateThresholdDialog.close();
                this.$refs.ThresholdList.getThresholdListData();
                this.$loading.hideLoadding();
              }
            },
            closeThresholdDetailDialog(){
                this.$refs.ThresholdDetailDialog.close();
            }
        }
    }
</script>

<style scoped>

</style>
